import moment from "moment";
import "moment/locale/bg";
import { useInput } from "react-admin";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useState } from "react";

const CustomTimeOnlyInput = props => {
  const { onChange, onBlur, required, validate, readOnly, disabled, ...rest } = props;

  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
  } = useInput({
    validate: [required],
    onChange,
    onBlur,
    readOnly,
    disabled,
    ...props,
  });

  const [isFieldInvalid] = useState(invalid);

  const handleChange = time => {
    if (!time || !moment(time).isValid()) {
      field.onChange(null);
      return;
    }

    field.onChange(moment(time).format("HH:mm:ss"));
  };

  // Ако стойността е "12:00:00" → преобразувай към moment
  const value = field?.value ? moment(field.value, "HH:mm:ss") : null;
  const showError = (isTouched || isSubmitted) && invalid;

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      dateLibInstance={moment.utc}
      adapterLocale="bg"
    >
      <TimePicker
        {...field}
        label={props.label}
        value={value}
        onChange={handleChange}
        ampm={false} // ✅ изключва AM/PM
        error={showError}
        validate={validate}
        helperText={(isTouched || isSubmitted) && isFieldInvalid ? error : ""}
        disabled={readOnly || disabled}
        required={required}
        slotProps={{
          actionBar: {
            actions: ["clear"],
          },
          textField: {
            helperText: invalid ? error?.message?.replace(/@@react-admin@@/, "").replace(/^"|"$/g, "") : "",
            error: invalid,
            InputProps: {
              style: {
                color: invalid ? "#9D1B53" : "",
              },
              readOnly,
              disabled: readOnly || disabled,
            },
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default CustomTimeOnlyInput;
